module.exports = __webpack_public_path__ + "static/media/salade-fruits.2562869f.svg";